document.addEventListener('visibilitychange', () => {
	if (document.activeElement) {
		document.activeElement.blur();
	}
});
